/**
 * Veraltete Chunks nach einem Deployment.
 *
 * Die Anwendung wird in hashbenannte Dateien zerlegt und seitenweise
 * nachgeladen. Nach einem Update gibt es die alten Dateien nicht mehr,
 * ein offener Browser-Tab kennt aber noch die alten Namen: der Seitenwechsel
 * scheitert mit "Failed to fetch dynamically imported module". Das ist kein
 * Fehler im Code, sondern der Normalfall nach jeder Auslieferung -- und der
 * Benutzer braucht genau eines: die neue Fassung.
 *
 * Einmal neu laden, mit Sperre. Ohne sie liefe eine Schleife, wenn die Datei
 * aus einem anderen Grund fehlt (Netz weg, Server kaputt).
 */
const SCHLUESSEL = 'chunk-neu-geladen-um';
const SPERRE_MS = 60_000;

export function istChunkLadefehler(grund: unknown): boolean {
  const text =
    typeof grund === 'string'
      ? grund
      : grund instanceof Error
        ? `${grund.name}: ${grund.message}`
        : '';
  return (
    /Failed to fetch dynamically imported module/i.test(text) ||
    /Importing a module script failed/i.test(text) ||
    /error loading dynamically imported module/i.test(text) ||
    /Unable to preload CSS/i.test(text)
  );
}

/** Laedt neu, hoechstens einmal pro Minute. Liefert true, wenn neu geladen wird. */
export function einmalNeuLaden(): boolean {
  try {
    const zuletzt = Number(sessionStorage.getItem(SCHLUESSEL) ?? 0);
    if (Date.now() - zuletzt < SPERRE_MS) return false;
    sessionStorage.setItem(SCHLUESSEL, String(Date.now()));
  } catch {
    // sessionStorage gesperrt: lieber kein Neuladen als eine Schleife.
    return false;
  }
  window.location.reload();
  return true;
}
